import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";
import { toast } from "react-toastify";
import * as moment from "moment";

const atcRosterAPI = () => {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllAtcRosterDetailsAPI(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
          const query = JSON.stringify(values);
          const res = await fetch(
            `${config.host}/panel/rp/atcRoster/allAtcRosters?query=${query}`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    
      async function getAtcFindOne(values) {
            try {
              const obj = {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
              };
              const query = JSON.stringify(values);
              let res = await fetch(`${config.host}/panel/rp/atcRoster/findOne?query=${query}`, obj);
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          } 

    //        async function getAllPracticesAPI(values) {
    //     try {
    //       const obj = {
    //         method: "GET",
    //         credentials: "include",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //       };
    //       const query = JSON.stringify(values);
    //       const res = await fetch(
    //         `${config.host}/panel/rp/poolPrepRoster/getAllPracticesAPI`,
    //         obj
    //       );
    //       return handleResponse(res);
    //     } catch (err) {
    //       handleError(err);
    //     }
    //   }
    
          async function updateAtcRosterAPI(value) {
            try {
              const obj = {
                method: "PUT",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(value),
              };
              let res = await fetch(`${config.host}/panel/rp/atcRoster/update`, obj);
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          }
    
      async function createAtcRosterAPI(value) {
        try {
          const obj = {
            method: "Post",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(value),
          };
          let res = await fetch(`${config.host}/panel/rp/atcRoster/create`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    
    return{
        getAllAtcRosterDetailsAPI,
        getAtcFindOne,
        updateAtcRosterAPI,
        createAtcRosterAPI,
        
    }
}
export default atcRosterAPI;
